// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l6c5","delete":"styles_delete__m9_MN","update":"styles_update__MvcBT","add":"styles_add__1nImE"};